module.exports = __webpack_public_path__ + "img/smart-utilities-depth.f1f210c3.webp";